import { render, staticRenderFns } from "./TakeQuizzMobileWidget.vue?vue&type=template&id=466fa7a5&scoped=true"
import script from "./TakeQuizzMobileWidget.vue?vue&type=script&lang=js"
export * from "./TakeQuizzMobileWidget.vue?vue&type=script&lang=js"
import style0 from "./TakeQuizzMobileWidget.vue?vue&type=style&index=0&id=466fa7a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466fa7a5",
  null
  
)

export default component.exports